// Copyright (c) 2020 Deere & Company

import './index.scss';

import AllBundlesOrdered from './all-bundles-ordered';
import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';

function AllBundlesOrderedPage () {

    return (
        <AuthenticatedPage className="atp-page atp-all-bundles-ordered-page">
            <AllBundlesOrdered />
        </AuthenticatedPage>
    );

}
AllBundlesOrderedPage.displayNAme = 'AllBundlesOrderedPage';

export default AllBundlesOrderedPage;
